import type React from 'react'

import { SkeletonTable } from '@/components/framework'

interface BookingLogTableSkeletonProps {
  loadingLabel: string
}

export const BookingLogTableSkeleton: React.FC<BookingLogTableSkeletonProps> = ({
  loadingLabel,
}) => (
  <div role="status" aria-busy="true" className="space-y-2">
    <span className="sr-only">{loadingLabel}</span>
    <SkeletonTable columns={3} rows={4} />
  </div>
)
